var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status === 'ok')?_c('v-avatar',{attrs:{"size":"10px","color":"green"}}):(_vm.status === 'error')?_c('v-avatar',{attrs:{"size":"10px","color":"red"}}):_c('v-avatar',{attrs:{"size":"10px","color":"grey"}})
}
var staticRenderFns = []

export { render, staticRenderFns }